import {
    COUNTER,
    INCIDENT_SERVICE_AGENCY,
    INCIDENT_SERVICE_AUDIT,
    INCIDENT_SERVICE_CLIENT,
    INCIDENT_SERVICE_CONTRACT,
    INCIDENT_SERVICE_DEVIS,
    INCIDENT_SERVICE_INTERVENTION,
    INCIDENT_SERVICE_PLACE,
    INCIDENT_SERVICE_SITE,
} from '@/utils/CONST';
import { useCreate } from 'react-admin';

type Service =
    | typeof INCIDENT_SERVICE_CONTRACT
    | typeof INCIDENT_SERVICE_CLIENT
    | typeof INCIDENT_SERVICE_INTERVENTION
    | typeof INCIDENT_SERVICE_SITE
    | typeof INCIDENT_SERVICE_PLACE
    | typeof INCIDENT_SERVICE_DEVIS
    | typeof INCIDENT_SERVICE_AGENCY
    | typeof INCIDENT_SERVICE_AUDIT;

interface Props {
    service: Service;
}

const useGetAlphaId = ({ service }: Props) => {
    const [create, { isLoading }] = useCreate();

    return {
        getAlphaId: () =>
            create(
                COUNTER,
                {
                    data: {
                        amount: 1,
                        service,
                    },
                    meta: {
                        basePath: 'counter',
                    },
                },
                {
                    returnPromise: true,
                },
            ),
        isLoadingGetAlphaId: isLoading,
    };
};

export default useGetAlphaId;
